import { assign, setup } from 'xstate';

export const trustMachine = setup({
  types: {
    context: {} as { sent: number; predictedReturnPct: number; note: string },
    events: {} as
      | { type: 'SET_SENT'; sent: number }
      | { type: 'SET_PREDICTION'; predictedReturnPct: number }
      | { type: 'SET_NOTE'; note: string }
      | { type: 'HUMAN_READY' }
      | { type: 'SUBMIT' }
      | { type: 'RESOLVE' }
      | { type: 'FAIL' }
      | { type: 'RESET' }
  }
}).createMachine({
  id: 'trustFlow',
  initial: 'reading',
  context: { sent: 5, predictedReturnPct: 0.5, note: '' },
  states: {
    reading: {
      on: {
        SET_SENT: { actions: assign({ sent: ({ event }) => event.sent }) },
        SET_PREDICTION: { actions: assign({ predictedReturnPct: ({ event }) => event.predictedReturnPct }) },
        SET_NOTE: { actions: assign({ note: ({ event }) => event.note }) },
        HUMAN_READY: 'armed'
      }
    },
    armed: {
      on: {
        SET_SENT: { actions: assign({ sent: ({ event }) => event.sent }) },
        SET_PREDICTION: { actions: assign({ predictedReturnPct: ({ event }) => event.predictedReturnPct }) },
        SET_NOTE: { actions: assign({ note: ({ event }) => event.note }) },
        SUBMIT: 'committing'
      }
    },
    committing: {
      on: {
        RESOLVE: 'locked',
        FAIL: 'armed'
      }
    },
    locked: {
      after: { 900: 'reading' },
      on: { RESET: 'reading' }
    }
  }
});
